// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608130634/js/" + chunkId + "." + {"44":"5ed7de1f","225":"4307eead","481":"5d943301","486":"53e55ea9","770":"d5a56e50"}[chunkId] + ".0.631940005765762.chunk.js";
};